import http from "@/api";
import { AdvertiserDataAnalysisParams, AdvertiserDataAnalysisItem, PageResponse, ApiResponse } from "@/api/interface/data";

/**
 * @name 数据分析模块
 */

// 获取广告账户数据分析
export const getAdvertiserDataAnalysis = async (params: AdvertiserDataAnalysisParams): Promise<PageResponse<AdvertiserDataAnalysisItem>> => {
    try {
        const response = await http.post<ApiResponse<PageResponse<AdvertiserDataAnalysisItem>>>(`/data_analysis/advertiser`, params);
        if (response?.code === 200 && response.data) {
            return response.data;
        }
        return {
            list: [],
            total: 0,
            size: params.pageSize,
            current: params.current
        };
    } catch (error) {
        console.error('Failed to fetch advertiser data:', error);
        return {
            list: [],
            total: 0,
            size: params.pageSize,
            current: params.current
        };
    }
};
